<template>
    <backend-layout title="Campaigns" :navs="navs" >
        <template v-slot:action>
            <assign-referrer :campaign="campaign.code" :referrers-count="referrers.data.length"></assign-referrer>
        </template>
        <div class="has-table md:rounded border-gray-100 dark:bg-gray-900/70 bg-white border dark:border-gray-800 mb-6"
             v-if="referrers.data.length > 0">
            <header class="card-header">
                <p class="card-header-title">
                    <span class="icon"><i class="mdi mdi-account-multiple"></i></span>
                    Influencers
                </p>
            </header>
            <div class="card-content">
                <table>
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Copy & Share (URL, Redeem CODE, or QR Code)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="referrer in referrers.data">
                        <td data-label="Name">{{ referrer.name }}</td>
                        <!--                        <td data-label="Referrer URL">-->
                        <!--                            <span :id="'referral-url-'+referrer.username"-->
                        <!--                                  v-html="displayUrl(referrer)"></span>-->
                        <!--                        </td>-->
                        <td class="actions-cell">
                            <div class="buttons nowrap">
                                <button class="button blue"
                                        type="button" @click="doCopy(displayUrl(referrer))" data-bs-toggle="tooltip"
                                        title="Copy Link">
                                    <span class="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                             fill="currentColor" class="bi bi-link" viewBox="0 0 16 16">
  <path
      d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9c-.086 0-.17.01-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z"/>
  <path
      d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4.02 4.02 0 0 1-.82 1H12a3 3 0 1 0 0-6H9z"/>
</svg>
                                    </span>
                                </button>
                                <button class="button green"
                                        @click="doCopy(displayCode(referrer),'Code')"
                                        type="button" data-bs-toggle="tooltip"
                                        title="Copy Code">
                                    <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                            fill="currentColor" class="bi bi-type" viewBox="0 0 16 16">
  <path
      d="m2.244 13.081.943-2.803H6.66l.944 2.803H8.86L5.54 3.75H4.322L1 13.081h1.244zm2.7-7.923L6.34 9.314H3.51l1.4-4.156h.034zm9.146 7.027h.035v.896h1.128V8.125c0-1.51-1.114-2.345-2.646-2.345-1.736 0-2.59.916-2.666 2.174h1.108c.068-.718.595-1.19 1.517-1.19.971 0 1.518.52 1.518 1.464v.731H12.19c-1.647.007-2.522.8-2.522 2.058 0 1.319.957 2.18 2.345 2.18 1.06 0 1.716-.43 2.078-1.011zm-1.763.035c-.752 0-1.456-.397-1.456-1.244 0-.65.424-1.115 1.408-1.115h1.805v.834c0 .896-.752 1.525-1.757 1.525z"/>
</svg></span>
                                </button>
                                <button class="button bg-red-100"
                                        type="button" data-bs-toggle="tooltip"
                                        title="Copy QR-Code"
                                        @click="downloadQrCode(referrer)"
                                        :id="displayCode(referrer)"
                                >
                                    <span class="icon" style="overflow: hidden">
                                       <qrcode-vue :class="displayCode(referrer)" :value="displayUrl(referrer)"
                                                   :size="'300'" level="H"/>
                                    </span>
                                </button>
                                <a :href="route('referrers.analytics',{'code':referrer.username})"
                                   class="button bg-pink-700 text-white" title="Analytics"
                                   type="button">
                                    <span class="icon"><i class="mdi mdi-chart-areaspline"></i></span>
                                </a>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <pagination :links="referrers.links" :active-page="referrers.current_page"
                            :total-pages="referrers.total"></pagination>
            </div>
            <canvas id="canvas"></canvas>
        </div>
        <div v-else>
            No referrers available for this campaign
        </div>
    </backend-layout>
</template>

<script>
import BackendLayout from "@/Layouts/BackendLayout";
import Pagination from "@/Components/Pagination";
import AssignReferrer from "@/Components/AssignReferrer";
import QrcodeVue from 'qrcode.vue';

export default {
    name: "CampaignReferrers",
    props: {
        campaign: Object,
        referrers: Object
    },
    components: {AssignReferrer, Pagination, BackendLayout, QrcodeVue},
    data() {
        return {
            navs: [{title: 'Influencers'}]
        }
    },
    methods: {
        displayUrl(ref) {
            return (this.$inertia.page.props.app_url + '/' + ref.pivot.campaign_referrer_url).toLowerCase();
        },
        displayCode(ref) {
            return ref.pivot.campaign_referrer_url
        },
        doCopy(text, action = 'Link') {
            this.$copyText(text)
                .then(() => {
                    console.log("copied!");
                    this.$toast.show(`Copied ${action}`);
                })
                .catch(() => {
                    console.log(`can't copy`);
                    this.$toast.error(`Failed to copy ${action}`);
                });
        },
        async downloadQrCode(ref) {
            // var svg = document.getElementsByClassName(this.displayCode(ref))[0];

            let triggerDownload = (imgURI, fileName) => {
                let a = document.createElement('a')

                a.setAttribute('download', `${ref.name}_${this.displayCode(ref).toLowerCase()}.png`)
                a.setAttribute('href', imgURI)
                a.setAttribute('target', '_blank')

                a.click()
            }

            // let save = () => {
            // let data = (new XMLSerializer()).serializeToString(svg)
            // let svgBlob = new Blob([data], {type: 'image/svg+xml;charset=utf-8'})
            // let url = URL.createObjectURL(svgBlob)

            // triggerDownload(url);
            let canvas = document.getElementsByClassName(this.displayCode(ref))[0];
            // let ctx = canvas.getContext('2d');
            let img = new Image();

            img.onload = function () {
                // ctx.drawImage(img, 0, 0);
                // DOMURL.revokeObjectURL(url);

                let imgURI = canvas
                    .toDataURL('image/png')
                    .replace('image/png', 'image/octet-stream');

                triggerDownload(imgURI);
            };

            img.src = canvas
                .toDataURL('image/png');
        }
    }
}
</script>

<style scoped>

</style>
